import { Badge, badgeClasses, styled } from '@mui/material'

export const AlertBadge = styled(Badge)(({ theme }) => ({
  [badgeClasses.badge]: {
    right: 3,
    top: 3,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.palette.background.paper,
    p: theme.spacing(0.5),
  },
}))
